import { HashRouter, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { AppProvider } from './context/AppContext.jsx';
import { NavBar } from './components/NavBar.jsx';
import { ToastStack } from './components/Toast.jsx';
import { cx } from './lib/util.js';
import ShiftCalculator from './pages/ShiftCalculator.jsx';
import InventoryAudit from './pages/InventoryAudit.jsx';
import Skyads from './pages/Skyads.jsx';
import Lifeinvader from './pages/Lifeinvader.jsx';
import ManagerPortal from './pages/ManagerPortal.jsx';
import Partner from './pages/Partner.jsx';

/* Routes that own the whole viewport instead of sitting inside the
   reading-width column — currently just the full-bleed partner embed. */
const FULL_BLEED_ROUTES = ['/partner'];

function AppShell() {
  const { pathname } = useLocation();
  const fullBleed = FULL_BLEED_ROUTES.some((route) => pathname.startsWith(route));

  return (
    // Full-bleed routes are pinned to the viewport so the embed inside them gets a
    // definite height to fill; every other route keeps the normal scrolling page.
    <div
      className={cx(
        'flex flex-col bg-void bg-grid text-snow',
        fullBleed ? 'h-dvh' : 'min-h-screen'
      )}
    >
      <NavBar />
      <main
        className={
          fullBleed
            ? 'flex min-h-0 flex-1 flex-col overflow-hidden'
            : 'mx-auto w-full max-w-6xl px-4 py-8'
        }
      >
        <Routes>
          <Route path="/" element={<Navigate to="/shift" replace />} />
          <Route path="/shift" element={<ShiftCalculator />} />
          <Route path="/audit" element={<InventoryAudit />} />
          <Route path="/skyads" element={<Skyads />} />
          <Route path="/lifeinvader" element={<Lifeinvader />} />
          <Route path="/partner" element={<Partner />} />
          <Route path="/manager" element={<ManagerPortal />} />
          <Route path="*" element={<Navigate to="/shift" replace />} />
        </Routes>
      </main>
      {/* No page chrome on full-bleed routes — every pixel goes to the embed. */}
      {!fullBleed && (
        <footer className="border-t border-edge py-6 text-center">
          <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-dim">
            Strawberry Gas · Open 24/7 · 1001 Strawberry Ave
          </p>
        </footer>
      )}
      <ToastStack />
    </div>
  );
}

export default function App() {
  return (
    <HashRouter>
      <AppProvider>
        <AppShell />
      </AppProvider>
    </HashRouter>
  );
}